export default "__VITE_ASSET__dUqcVVfh__"